module.exports = __webpack_public_path__ + "static/media/burgerapp (2).5b96aaac.png";